// removes rotation hint when user appears to understand it
if (screen.addEventListener) {
  screen.addEventListener("orientationchange", function () {
    console.log("screen orientationchange: ", screen.orientation);
    if (/landscape/.test(screen.orientation.type)) {
      const el = document.querySelector('.portraitOnly');
      if (el) {
        el.parentElement.removeChild(el);
      }
    }
  });
} else {
  window.addEventListener("orientationchange", function () {
    console.log("window orientationchange: ", screen.orientation && screen.orientation.type);
    const el = document.querySelector('.portraitOnly');
    if (el) {
      el.parentElement.removeChild(el);
    }
  });
}
